import Axios from "axios";
import {
    SET_PURPOSE_LIST,
    UNSET_PURPOSE_LIST,
  } from "@/store/mutation-types";
import { purposeResource } from "@/store/api";
// initial state
const state = {
  getPurposeList: [],
};

const getters = {
  getPurposeList(state) {
    return state.getPurposeList;
  },
};
const mutations = {
  [SET_PURPOSE_LIST](state, data) {
    state.getPurposeList = data;
  },
  [UNSET_PURPOSE_LIST](state) {
    state.getPurposeList = [];
  },
};

const actions = {

  saveUpdatePurpose({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(purposeResource, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getPurposeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(purposeResource, data)
        .then(function (response) {
          commit('SET_PURPOSE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PURPOSE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
